import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import blur from '@mailobj-browser/front/js/events/types/blur.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import mouseOut from '@mailobj-browser/front/js/events/types/mouseOut.js'
import mouseOver from '@mailobj-browser/front/js/events/types/mouseOver.js'
import mouseUp from '@mailobj-browser/front/js/events/types/mouseUp.js'
import readystatechange from '@mailobj-browser/front/js/events/types/readyStateChange.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import * as rte from '#utilities/js/rte/rte.js'

const onLoad = object(listener, {
  type: load,
  passive,
  once,
  task: (
    iframe
  ) => {
    const { contentDocument } = iframe
    const { readyState } = contentDocument

    if (readyState === 'complete') {
      onReadyStateChange.task(contentDocument)
    } else {
      onReadyStateChange.listen(contentDocument)
    }

    onMouseOver.listen(iframe)
    onMouseOut.listen(iframe)
    onMouseUp.listen(iframe)
    rte.onLoad.trigger(iframe)
    onBlur.listen(contentDocument)
  }
})

const onReadyStateChange = object(listener, {
  type: readystatechange,
  passive,
  task: (
    contentDocument
  ) => {
    const { readyState } = contentDocument

    if (readyState === 'complete') {
      contentDocument.designMode = 'on'
      onReadyStateChange.forget(contentDocument)
    }
  }
})

const onBlur = object(listener, {
  type: blur,
  passive,
  task: (
    contentDocument
  ) => {
    const { defaultView, body } = contentDocument
    const { top } = defaultView
    const { document } = top
    const msgText = one(`input[name='msg_text']`, document)

    msgText.value = body.innerHTML
  }
})

const onMouseOver = object(listener, {
  type: mouseOver,
  passive,
  task: () => {
    globals.ea_mouse_drag_test('html_id')
  }
})

const onMouseOut = object(listener, {
  type: mouseOut,
  passive,
  task: () => {
    globals.ea_mouse_drag_test('')
  }
})

const onMouseUp = object(listener, {
  type: mouseUp,
  passive,
  task: (
    iframe
  ) => {
    const { id } = iframe
    globals.ea_mouse_drop('html_id', 'ea_rte_drag', id)
  }
})

export default iframe => {
  const { contentDocument } = iframe

  if (contentDocument) {
    return onLoad.task(iframe)
  }

  onLoad.listen(iframe)
}